import {
    INIT_OIL_LIST_REQUEST,
    SET_OIL_LIST,
    ERROR_OIL_LIST,
    INIT_OIL_REQUEST,
    SET_OIL,
    ADD_OIL,
    ERROR_OIL_REQUEST,
    DELETE_OIL
  } from './action';
  
  const initialState = {
    data: [],
    error: null,
    isLoading: false,
    selectedOil: null,
  };
  
  const oilListReducer = (state = initialState, action) => {
    switch (action.type) {
      case INIT_OIL_LIST_REQUEST:
        return {
          ...state,
          isLoading: true,
          error: null,
        };
  
      case SET_OIL_LIST:
        return {
          ...state,
          data: action.payload,
          isLoading: false,
          error: null,
        };
  
      case ADD_OIL:
        return {
          ...state,
          isLoading: false,
          error: null,
        };
  
      case ERROR_OIL_LIST:
        return {
          ...state,
          data: [],
          isLoading: false,
          error: action.payload,
        };
  
      case INIT_OIL_REQUEST:
        return {
          ...state,
          isLoading: true,
          error: null,
          selectedOil: null,
        };
  
      case SET_OIL:
        return {
          ...state,
          isLoading: false,
          selectedOil: action.payload,
          error: null,
        };
  
      case ERROR_OIL_REQUEST:
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      
      case DELETE_OIL:
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default oilListReducer;
  